import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoaderService {

  public isLoading$ = new BehaviorSubject<boolean>(false);

  public showLoader() {
    setTimeout(() => this.isLoading$.next(true));
  }

  public hideLoader() {
    setTimeout(() => this.isLoading$.next(false));
  }

  public getLoaderStatus() {
    return this.isLoading$.getValue();
  }

}
